import themeConstants from '../../../../layout/Theme';

const styles = () => ({
  restaurantImg: {
    objectFit: 'cover',
    objectPosition: 'center',
  },
  button: {
    boxSizing: 'border-box',
    width: '150px',
    minWidth: '150px',
    height: '50px',
    backgroundColor: themeConstants.colors.primary,
    color: 'white',
    marginTop: '10px',
    [themeConstants.screenSize.mobile]: {
      width: '100%',
      marginTop: '15px',
    },
  },
  elementText: {
    marginTop: '10px',
  },
  mainView: {},
  viewElement: {
    width: '100%',
    maxHeight: '512px',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  aboutUsTitle: {
    padding: '5px',
  },
});

export default styles;
